import { mapGetters } from 'vuex';

export default {
  mounted() {
    if (this.locale !== this.$i18n.locale) {
      this.$i18n.locale = this.locale;
    }
  },
  computed: {
    ...mapGetters(['locale']),
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/i18n.js